import React, { useEffect, useState } from 'react';
import Maps from '../components/Maps';
import axios from 'axios';

export async function transformAddress(address){
   let response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDpcyyTwsGXzVMphjQ3s885lors1FkG1Cw&sensor=false&address=${address}`);

   try{
      return response.data.results[0].access_points[0].location;
   }catch(e){
      return {latitude: 0.000000, longitude: 0.000000};
   }
}

const Busca = (props) => {

   var query = window.location.search.slice(1);
   var partes = query.split('&');
   var data = {};
   partes.forEach(function (parte) {
      var chaveValor = parte.split('=');
      var chave = chaveValor[0];
      var valor = chaveValor[1];
      data[chave] = valor;
   });

   const [locationCity, setLocationCity] = useState({});


   useEffect(() => {
      async function loadCityInMap(){
         try{
            const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDpcyyTwsGXzVMphjQ3s885lors1FkG1Cw&sensor=false&address=${data.city}`);
   

            setLocationCity(response.data.results[0].access_points[0].location);
         } catch(error) {

            setLocationCity({latitude: 40.854885, longitude: -88.081807});
         }
      }

      loadCityInMap();
   },[data.city])
   
   return(
      <div className="map">
         <Maps city={locationCity}/>
      </div>
      
   )
}

export default Busca;
